import { useEffect, useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { getVaultIntegrationDomain } from '@alucio/aws-beacon-amplify/src/graphql/queries';

interface DomainRequest {
  tenantId: string;
  integrationId?: string | null;
  enabled: boolean;
}

interface DomainResult {
  tenantId: string;
  integrationId: string;
  domain: string | null;
  hasError: boolean;
}

export const useVaultIntegrationDomain = ({ tenantId, integrationId, enabled }: DomainRequest) => {
  const [result, setResult] = useState<DomainResult>();
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setResult(undefined);
    if (!enabled || !integrationId) return;
    let active = true;
    const loadDomain = async () => {
      try {
        const { data } = await generateClient().graphql({
          query: getVaultIntegrationDomain,
          variables: { integrationId },
        });
        if (active) {
          setResult({ tenantId, integrationId, domain: data.getVaultIntegrationDomain ?? null, hasError: false });
        }
      } catch {
        if (active) setResult({ tenantId, integrationId, domain: null, hasError: true });
      }
    };
    loadDomain();
    return () => { active = false; };
  }, [tenantId, integrationId, enabled, attempt]);

  const current = enabled && result?.tenantId === tenantId && result?.integrationId === integrationId
    ? result : undefined;
  return {
    domain: current?.domain ?? null,
    hasError: current?.hasError ?? false,
    retry: () => setAttempt(value => value + 1),
  };
};
